/** Image/video files from a paste or drop DataTransfer (files + items APIs). */
export function filesFromClipboard(data: DataTransfer | null | undefined): File[] {
  if (!data) return [];
  const out: File[] = [];
  const seen = new Set<string>();
  const push = (file: File) => {
    if (!/^image\//i.test(file.type) && !/^video\//i.test(file.type)) return;
    // Prefer size+type: files[] and items.getAsFile() often differ on name/lastModified.
    const key = `${file.size}:${(file.type || '').toLowerCase()}`;
    if (seen.has(key)) return;
    seen.add(key);
    const named = (!file.name || file.name === 'image.png' || file.name === 'blob')
      ? new File([file], `colado-${Date.now()}-${out.length}.${/^video\//i.test(file.type) ? 'mp4' : 'png'}`, {
        type: file.type || 'image/png',
        lastModified: file.lastModified || Date.now(),
      })
      : file;
    out.push(named);
  };
  // Prefer `items` (screenshots / copied bitmaps). Skip `files` when items already
  // yielded media — reading both duplicates the same paste on Chromium/Windows.
  let fromItems = 0;
  if (data.items?.length) {
    Array.from(data.items).forEach((item) => {
      if (item.kind !== 'file') return;
      if (!/^image\//i.test(item.type) && !/^video\//i.test(item.type)) return;
      const file = item.getAsFile();
      if (!file) return;
      const before = out.length;
      push(file);
      if (out.length > before) fromItems += 1;
    });
  }
  if (fromItems > 0) return out;
  if (data.files?.length) {
    Array.from(data.files).forEach(push);
  }
  return out;
}
